import { IModalFormField as SharedIModalFormField } from '@components-shared/forms/formField.interface';
import { FormUtils } from '@components-shared/forms/forms.utils';
import { LEVERAGE } from '@components-shared/socialTrading/enums';
import { RecommendedMinDepositLimitsType } from '@components-shared/socialTrading/interfaces';
import { fetchApi } from 'api/fetchApi';
import { IApiCopyType, IApiGroupMappingType } from 'api/interfaces/data-contracts';
import { AxiosResponse } from 'axios';

export const getInfoAboutOpenOrders = async (path: string, id: number): Promise<AxiosResponse<boolean>> =>
  await fetchApi.get<boolean>(path, { params: { id } });

export const minDepositLimitsAreConfigured = (
  recommendedMinDepositLimits: RecommendedMinDepositLimitsType[],
  accountGroupMappingType: IApiGroupMappingType,
): boolean => {
  return recommendedMinDepositLimits.some(({ groupMappingType }) => groupMappingType === accountGroupMappingType);
};

export const isLotCopyTypeCheck = (copyType?: IApiCopyType): boolean => {
  return copyType === IApiCopyType.Lot;
};

export const leverageFieldHandler = (
  masterLeverage: number,
  fields: SharedIModalFormField[],
  isUpdateLeverageAllowed: boolean,
  leverages?: { value: number }[],
) => {
  if (!isUpdateLeverageAllowed) {
    return;
  }

  const leverageFieldIdx = FormUtils.getFieldIndex(fields, LEVERAGE);

  if (leverages) {
    const leverageFromMaster = { value: masterLeverage };

    if (!leverages.some((option) => option.value === masterLeverage)) {
      leverages.unshift(leverageFromMaster);
    }

    FormUtils.updateFormField(
      leverageFieldIdx,
      {
        options: leverages,
        attributes: { disabled: !isUpdateLeverageAllowed },
      },
      fields,
    );
  }
};
